import BaseService from '@/api/base.service';
import configApi from '@/api/config';
import grapePerksAppService from '@/api';

class ReviewService extends BaseService {
  constructor() {
    super({ baseUrl: configApi.baseRoutesUrls.reviews });
  }

  getReviewsOverview = () => grapePerksAppService.get(
    `${this.baseUrl}/overview`,
  ).then((resp) => resp.data);

  getGoogleReviews = () => grapePerksAppService.get(
    `${this.baseUrl}/google`,
  ).then((resp) => resp.data);

  getReviewBrandingDetails = (tenantUrlLinksSuffix) => grapePerksAppService.get(
    `${this.baseUrl}/branding/${tenantUrlLinksSuffix}`,
  ).then((resp) => resp.data);

  getReviewContactDetails = (tenantUrlLinksSuffix, contactToken) => grapePerksAppService.get(
    `${this.baseUrl}/contact/${tenantUrlLinksSuffix}/${contactToken}`,
  ).then((resp) => resp.data);

  postReview = (payload, tenantUrlLinksSuffix) => grapePerksAppService.post(
    `${this.baseUrl}/${tenantUrlLinksSuffix}`, payload,
  ).then((resp) => resp.data);

  deleteReviews = ({ data = null, filters = {} }) => this.deleteMany({
    data: data ? data.map((t) => t.id) : null,
    filters,
  });

  deleteReview = (id) => this.delete(id);
}

const singletonInstance = new ReviewService();

/**
 * tenant service api instance
 * @exports api/modules/tenant
 * */
export default singletonInstance;
